export const AREAS_EN = [
  {
    key: 'salute',
    name: 'Health',
    path: '/cassa-malati',
    icon: 'HeartPulse',
    short: 'Mandatory health insurance and supplementary cover, maternity, switching insurers: healthcare decisions made calmly, with the facts in hand.',
    image: '/assets/soluzione-salute.png',
  },
  {
    key: 'privati',
    name: 'Individuals',
    path: '/soluzioni/privati',
    icon: 'Home',
    short: 'Personal liability, household contents, vehicles, home: everyday protection for people and families, through life\u2019s changes.',
    image: '/assets/soluzione-privati.png',
  },
  {
    key: 'aziende',
    name: 'Businesses',
    path: '/soluzioni/aziende',
    icon: 'Building2',
    short: 'From launch to growth: we map your company\u2019s operational risks and build a coherent insurance programme.',
    image: '/assets/soluzione-aziende.png',
  },
  {
    key: 'previdenza',
    name: 'Pension',
    path: '/soluzioni/previdenza',
    icon: 'PiggyBank',
    short: 'Protecting tomorrow\u2019s income: the three pillars, loss of earnings, savings and coordinated planning.',
    image: '/assets/soluzione-previdenza.png',
  },
];

export const NAV_EN = [
  { label: 'Home', href: '/' },
  {
    label: 'Solutions',
    href: '/soluzioni',
    children: [
      { label: 'Overview', href: '/soluzioni', description: 'Four areas and our advisory method.' },
      { label: 'Health', href: '/cassa-malati', description: 'Basic, supplementary, accident and income.' },
      { label: 'Individuals', href: '/soluzioni/privati', description: 'Home, family, mobility and assets.' },
      { label: 'Businesses', href: '/soluzioni/aziende', description: 'People, liability and continuity.' },
      { label: 'Pension', href: '/soluzioni/previdenza', description: 'LPP, gaps, pillars 3a/3b and retirement.' },
    ],
  },
  {
    label: 'Guides',
    href: '/guide',
    children: [
      { label: 'Moving to Switzerland', href: '/guide/privati/trasferirsi-in-svizzera' },
      { label: 'Living on your own', href: '/guide/privati/andare-a-vivere-da-soli' },
      { label: 'Buying a home at 30', href: '/guide/privati/comprare-casa-a-30-anni' },
      { label: 'Going self-employed', href: '/guide/privati/mettersi-in-proprio' },
      { label: 'Importing a car', href: '/guide/privati/importare-auto-in-svizzera' },
      { label: 'Switching health insurers', href: '/guide/salute/cambio-cassa-malati-premi-disdetta' },
      { label: 'Prenatal insurance', href: '/guide/salute/assicurazione-prenatale' },
      { label: 'Starting a business', href: '/guide/aziende/aprire-un-azienda' },
      { label: 'Legal forms', href: '/guide/aziende/forme-giuridiche-svizzera' },
    ],
  },
  { label: 'Claims centre', href: '/centro-sinistri' },
  { label: 'About us', href: '/chi-siamo' },
  { label: 'Refer someone', href: '/consiglio-a-terzi' },
  { label: 'Contact', href: '/contatti' },
];

export const HOME_FAQ_EN = [
  { q: 'How much does a consultation cost?', a: 'The first introductory meeting is free and without obligation. Before any engagement we clearly explain how we work and how our service is remunerated.' },
  { q: 'Can you review contracts I already have?', a: 'Yes. Reviewing existing cover is a core part of our work: we check for overlaps, gaps and conditions, then present the alternatives in plain language.' },
  { q: 'Do you work with individuals and businesses?', a: 'Yes, we support people and families as well as companies of different sizes, from business launch to periodic reviews of the insurance programme.' },
  { q: 'Will you help me in the event of a claim?', a: 'Yes. In the event of a claim we help you gather the information, avoid the most common mistakes and deal with the insurer. You can start from our Claims centre.' },
  { q: 'Can I request an online consultation?', a: 'Yes, we offer phone calls and video calls as well as office meetings. You can indicate your preferred option in the contact form.' },
];

export const LEGAL_PAGES_EN = {
  '/privacy': {
    title: 'Privacy Policy',
    updated: '15 August 2026',
    intro: 'This notice explains how Unity Consulting processes personal data through the website, which technologies are actually integrated in the current code, and what choices are available to visitors.',
    sections: [
      {
        title: '1. Data controller',
        paragraphs: [
          'The data controller is Unity Consulting di Matteo Vairani, sole proprietorship, Via Antonio Chiesa 12a, 6830 Chiasso, Switzerland, UID CHE-275.494.791. For data-protection requests, you may use the contact details or contact page made available on the website.',
          'Processing is carried out in accordance with the Swiss Federal Act on Data Protection (FADP) and other applicable Swiss rules. The GDPR is taken into account where it applies to a particular processing activity or data subject.',
        ],
      },
      {
        title: '2. Data processed through the website',
        paragraphs: [
          'During normal delivery of the website, the hosting infrastructure may process technical information required to serve and secure the service, such as IP address, request date and time, requested URL, user agent, device information and similar technical data.',
          'The contact, referral and claim-report forms collect, depending on the form, name, contact details, topic, message, referred-person details and information relating to a claim, including uploaded documents. The data is transmitted over an encrypted connection to Unity Consulting\u2019s infrastructure so that the request can be received and handled; contact and referral forms also send a receipt to the email address provided.',
          'A claim report may voluntarily include sensitive personal data, such as health information. Please provide only information that is genuinely necessary to handle the request.',
        ],
      },
      {
        title: '3. Purposes of processing',
        items: [
          'deliver the website and maintain its stability, security and correct display;',
          'handle contact or advisory requests when an actually active communication channel is used;',
          'handle claim reports and, where necessary, communicate with insurers or other parties involved in the engagement;',
          'statistically measure website use through Google Analytics 4 only after consent;',
          'comply with legal or regulatory obligations and requests from competent authorities.',
        ],
        paragraphs: [
          'Where the GDPR applies, processing strictly necessary to handle a request may rely on pre-contractual or contractual steps, legal obligations and applicable legitimate interests; Google Analytics is enabled on the basis of consent. Explicit consent is requested where necessary for sensitive data voluntarily included in a claim report.',
        ],
      },
      {
        title: '4. Google Analytics 4',
        paragraphs: [
          'The website integrates Google Analytics 4 with measurement ID G-B0PCHJ3ETB. The integration is opt-in: the Google script is not loaded before the visitor makes a choice, and navigation events are not sent to Analytics without consent.',
          'When Analytics is authorised, the website sends page-view events and Google may process technical and usage information, online identifiers, device characteristics and approximate geographic location. In the website code, advertising storage, advertising user data and ad personalisation remain denied; Google Signals and advertising personalisation are disabled.',
          'Google states that, for Google Analytics, IP addresses are used to derive approximate geographic information and are not stored or logged in Analytics systems. Google may nevertheless process data within its international infrastructure under its own terms and transfer mechanisms.',
        ],
      },
      {
        title: '5. Cookies and preference storage',
        paragraphs: [
          'The first-party necessary cookie \u201cunity_cookie_consent\u201d is used to remember the choice for up to 180 days. The same preference is also stored in browser localStorage as a technical continuity copy under the key \u201cunity_cookie_consent_v2\u201d.',
          'Only after consent to Google Analytics may the first-party cookies \u201c_ga\u201d and \u201c_ga_<container-id>\u201d be created. Google states a default expiration of 2 years for both, subject to browser limits and Analytics property settings.',
          'You can reject analytics without losing access to the website and can change your decision at any time through \u201cCookie preferences\u201d in the footer.',
        ],
      },
      {
        title: '6. Recipients and international transfers',
        paragraphs: [
          'Technical data required to deliver the website may be processed by the hosting provider and commissioned technical suppliers. When Google Analytics is active, data is processed by Google and its subprocessors under the service\u2019s contractual and privacy documentation.',
          'Use of international services may involve processing outside Switzerland. Depending on the destination and provider, adequacy decisions, recognised frameworks or other safeguards provided by applicable law may apply, including standard contractual clauses where required.',
        ],
      },
      {
        title: '7. Retention',
        paragraphs: [
          'Data is retained only for as long as required for the purposes for which it is processed and for applicable legal obligations. Technical log retention depends on hosting configuration and security needs. The cookie choice is remembered for a maximum of 180 days.',
          'For Google Analytics, retention of data associated with cookies and identifiers depends on the actual GA4 property settings; Google states a default cookie lifetime of up to 2 years. The Analytics account configuration should remain consistent with this notice.',
        ],
      },
      {
        title: '8. Data-subject rights',
        paragraphs: [
          'Within the limits provided by law, you may request confirmation of processing, access, correction, deletion, restriction or objection and, where applicable, delivery or portability of data. Where processing is based on consent, consent may be withdrawn at any time without affecting the lawfulness of earlier processing.',
          'You may also contact the Swiss Federal Data Protection and Information Commissioner (FDPIC) or, where the GDPR applies, the competent supervisory authority.',
        ],
      },
      {
        title: '9. Security and updates',
        paragraphs: [
          'Unity Consulting applies technical and organisational measures appropriate to the risk to protect data against unauthorised access, loss, alteration or improper disclosure. No Internet transmission can, however, be guaranteed to be absolutely secure.',
          'This notice is updated when the website, suppliers or processing activities change. The latest review date appears at the top of the page.',
        ],
      },
    ],
    resources: [
      { label: 'FDPIC - Duty to provide information', href: 'https://www.edoeb.admin.ch/en/duty-to-provide-information' },
      { label: 'Google Privacy Policy', href: 'https://policies.google.com/privacy?hl=en' },
      { label: 'Google Analytics - Privacy and data', href: 'https://support.google.com/analytics/topic/2919631?hl=en' },
    ],
  },
  '/cookie-policy': {
    title: 'Cookie Policy',
    updated: '15 August 2026',
    intro: 'This Cookie Policy describes only the technologies identified in the current website code: one necessary preference technology and, with prior consent, Google Analytics 4.',
    sections: [
      {
        title: '1. What the website uses',
        paragraphs: [
          'The website does not require advertising or marketing cookies to function. A necessary technology remembers the visitor\u2019s choice; Google Analytics 4 is optional and remains blocked until consent is given.',
        ],
      },
      {
        title: '2. Necessary consent technology',
        items: [
          'unity_cookie_consent - provider: Unity Consulting; purpose: remember whether Analytics was accepted or rejected; maximum duration: 180 days; category: necessary.',
          'unity_cookie_consent_v2 - localStorage; purpose: keep a technical copy of the consent preference and restore it when the cookie is unavailable; duration: until manually cleared or overwritten by a new preference; category: necessary.',
        ],
        paragraphs: [
          'These technologies are not used for profiling, advertising or audience measurement.',
        ],
      },
      {
        title: '3. Google Analytics 4 - optional',
        items: [
          '_ga - provider: Google Analytics; purpose: distinguish users; default expiration stated by Google: 2 years.',
          '_ga_<container-id> - provider: Google Analytics; purpose: persist session state; default expiration stated by Google: 2 years.',
        ],
        paragraphs: [
          'The gtag.js tag with measurement ID G-B0PCHJ3ETB is loaded only after consent. The website does not enable Google Signals, advertising personalisation, ad_storage, ad_user_data or ad_personalization.',
          'Technical domains involved may include googletagmanager.com and google-analytics.com. Actual cookie lifetime may be shortened by the browser or by Google Analytics property settings.',
        ],
      },
      {
        title: '4. How the banner works',
        paragraphs: [
          'On the first visit you can choose \u201cNecessary only\u201d, \u201cCustomise\u201d or \u201cAccept analytics\u201d. In the customisation panel, necessary technologies are always active and Analytics is off by default until selected.',
          'Rejecting analytics does not restrict access to the content. The choice can be changed at any time through \u201cCookie preferences\u201d in the footer. When consent is withdrawn, the website blocks new Analytics events and attempts to remove GA4 cookies accessible from the current domain.',
        ],
      },
      {
        title: '5. Browser controls and future changes',
        paragraphs: [
          'You can also delete cookies and localStorage through your browser settings. Clearing the preference will make the banner appear again on the next visit.',
          'If embedded videos, maps, advertising pixels, chats, marketing tools or other third-party services are added in the future, they should be assessed and, where required, blocked before consent and described on this page.',
        ],
      },
    ],
    resources: [
      { label: 'Google Analytics - Cookie usage on websites', href: 'https://support.google.com/analytics/answer/11397207?hl=en' },
      { label: 'Google - Consent Mode', href: 'https://support.google.com/analytics/answer/10000067?hl=en' },
      { label: 'Google Privacy Policy', href: 'https://policies.google.com/privacy?hl=en' },
    ],
  },
  '/note-legali': {
    title: 'Legal notice',
    updated: '15 August 2026',
    intro: 'This notice identifies the website operator and defines the informational nature of the content published by Unity Consulting.',
    finmaRegistration: {
      label: 'FINMA registration number',
      number: 'F01574165',
      href: 'https://www.finma.ch/en/authorisation/insurance-intermediaries/registersuche/',
    },
    sections: [
      {
        title: '1. Website operator',
        paragraphs: [
          'Unity Consulting di Matteo Vairani, sole proprietorship, Via Antonio Chiesa 12a, 6830 Chiasso, Switzerland. UID: CHE-275.494.791. Commercial Register of the Canton of Ticino: CH-501.1.024.806-4.',
          'The registered business purpose includes consulting, brokerage and management in the insurance and financial fields, together with related planning and risk-management activities for private and business clients.',
        ],
      },
      {
        title: '2. Insurance intermediation',
        paragraphs: [
          'Insurance intermediation is subject to the Swiss Insurance Supervision Act (ISA) and related regulation. Mandatory information concerning the intermediary, including information relevant under Articles 45, 45a and 45b ISA, is provided to clients in the required form and at the required time before conclusion of an insurance contract or within the advisory relationship.',
          'The FINMA registration number published on the website is F01574165. The registration status can be checked in the public FINMA register through the link shown on this page.',
        ],
      },
      {
        title: '3. Nature of website content',
        paragraphs: [
          'Information, guides, examples, checklists and comparisons on this website are general and informational. On their own, they do not constitute personalised insurance, financial, tax or legal advice, a binding offer or a purchase recommendation.',
          'Premiums, terms, cover, exclusions, cancellation periods, requirements and rules may change. Any concrete decision should be based on up-to-date contractual documents, insurer terms and the client\u2019s individual circumstances.',
        ],
      },
      {
        title: '4. Accuracy and liability',
        paragraphs: [
          'Unity Consulting prepares website content with care, but does not guarantee that every page will at all times be complete, error-free or updated for legislative, regulatory, tariff or contractual changes occurring after the stated review date.',
          'To the extent permitted by law, Unity Consulting is not liable for decisions made solely on the basis of general website content, temporary unavailability, technical errors or the content of linked external websites.',
        ],
      },
      {
        title: '5. External links',
        paragraphs: [
          'Links to FINMA, authorities, insurers, suppliers or other websites are provided for convenience. Unity Consulting does not continuously control the content, availability or privacy practices of those sites; the respective operator\u2019s terms apply when you visit them.',
        ],
      },
      {
        title: '6. Intellectual property',
        paragraphs: [
          'Unless otherwise stated, original texts, editorial structure, graphic elements and content of the website are protected by applicable copyright and other intellectual-property rules. Third-party trademarks, logos and materials remain the property of their respective owners.',
          'Reproduction, publication or substantial reuse beyond uses permitted by law requires authorisation from the holder of the relevant rights.',
        ],
      },
      {
        title: '7. Applicable law',
        paragraphs: [
          'The website and this notice are governed by Swiss law, without prejudice to any mandatory rights applicable to the data subject or client. Contractual relationships are also governed by the specific agreements and documents executed by the parties.',
        ],
      },
    ],
    resources: [
      { label: 'FINMA public register of insurance intermediaries', href: 'https://www.finma.ch/en/authorisation/insurance-intermediaries/registersuche/' },
      { label: 'Zefix central business name index', href: 'https://www.zefix.ch/en/search/entity/list/firm/1623719' },
    ],
  },
};

export const DISCLAIMER_EN = 'The content of this page is for information purposes only and does not replace individual advice. Conditions, premiums, cancellation terms and cover must always be verified in the contract and with the insurer concerned.';
